import { generateId } from '../../components/utils/helpers';

export const google_my_business_color = () => {
  const id = generateId();
  const id1 = `icon-google-my-business-color-id1-${id}`;
  const id2 = `icon-google-my-business-color-id2-${id}`;
  const id3 = `icon-google-my-business-color-id3-${id}`;

  return (
    <>
      <path
        d="M4.22554 6.80878H19.7331C20.7151 6.80878 21.5113 7.6049 21.5113 8.58697V19.4245C21.5113 20.4065 20.7151 21.2027 19.7331 21.2027H4.22554C3.24347 21.2027 2.44735 20.4065 2.44735 19.4245V8.58697C2.44735 7.6049 3.24347 6.80878 4.22554 6.80878Z"
        fill="#4788F8"
      />
      <mask
        id={id1}
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="6"
        width="20"
        height="16"
      >
        <path
          d="M4.22554 6.80878H19.7331C20.7151 6.80878 21.5113 7.6049 21.5113 8.58697V19.4245C21.5113 20.4065 20.7151 21.2027 19.7331 21.2027H4.22554C3.24347 21.2027 2.44735 20.4065 2.44735 19.4245V8.58697C2.44735 7.6049 3.24347 6.80878 4.22554 6.80878Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${id1})`}>
        <path
          d="M20.5362 6.7054H3.23494C2.699 6.7054 2.28195 10.8531 2.28195 11.3891L11.7566 21.2074H20.5362C21.0737 21.2059 21.5092 20.7705 21.5107 20.2329V7.67969C21.5091 7.14218 21.0737 6.70688 20.5362 6.7054Z"
          fill={`url(#${id2})`}
        />
        <rect
          x="2.06278"
          y="6.04373"
          width="19.8744"
          height="7.72895"
          fill={`url(#${id3})`}
        />
      </g>
      <path
        d="M6.50061 9.21885H12.0006V2.0002H7.32417L6.50061 9.21885V9.21885Z"
        fill="#4A58BD"
      />
      <path
        d="M17.5006 9.21885H12.0006V2.0002H16.6771L17.5006 9.21885V9.21885Z"
        fill="#7DABFB"
      />
      <path
        d="M21.3551 3.36858L21.5373 3.92065C21.4932 3.7258 21.4048 3.54487 21.3551 3.36858Z"
        fill="#7BABF7"
      />
      <path
        d="M21.362 3.39299L21.3552 3.36838C21.1808 2.56991 20.4741 2.00051 19.6568 2H16.6771L17.5 9.21885H23L21.362 3.39299Z"
        fill="#4A58BD"
      />
      <path
        d="M2.82142 3.36858L2.63923 3.92065C2.6834 3.7258 2.77173 3.54487 2.82142 3.36858Z"
        fill="#7BABF7"
      />
      <path
        d="M2.63904 3.39299L2.64586 3.36838C2.82024 2.56991 3.52696 2.00051 4.34425 2H7.32417L6.5 9.21885H1L2.63904 3.39299Z"
        fill="#7DABFB"
      />
      <path
        d="M6.50992 9.21698C6.50992 10.7349 5.2794 11.9654 3.76147 11.9654C2.24354 11.9654 1.01302 10.7349 1.01302 9.21698H6.50992Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7DA4E6"
      />
      <path
        d="M12.0068 9.21698C12.0068 10.7349 10.7763 11.9654 9.25836 11.9654C7.74043 11.9654 6.50991 10.7349 6.50991 9.21698H12.0068Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4855AF"
      />
      <path
        d="M17.5037 9.21698C17.5037 10.7349 16.2732 11.9654 14.7553 11.9654C13.2373 11.9654 12.0068 10.7349 12.0068 9.21698H17.5037Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7DA4E6"
      />
      <path
        d="M23 9.21698C23 10.7349 21.7695 11.9654 20.2515 11.9654C18.7336 11.9654 17.5031 10.7349 17.5031 9.21698H23Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4855AF"
      />
      <path
        d="M19.9003 16.6645C19.8918 16.5495 19.8776 16.4444 19.8574 16.3103H17.2219C17.2219 16.6789 17.2219 17.0811 17.2204 17.4499H18.7472C18.6817 17.7971 18.4806 18.1038 18.1883 18.3022C18.1883 18.3022 18.1883 18.2959 18.1872 18.2957C18.0003 18.4184 17.7898 18.5006 17.5692 18.5369C17.348 18.5773 17.1213 18.5764 16.9005 18.534C16.6763 18.4876 16.464 18.3956 16.2769 18.2637C16.0006 18.0678 15.7876 17.7955 15.6638 17.4803C15.6543 17.4558 15.6456 17.431 15.6367 17.406V17.4032L15.6391 17.4014C15.519 17.0489 15.5186 16.6665 15.6382 16.3137C15.7224 16.0663 15.8609 15.8408 16.0437 15.654C16.4724 15.2105 17.113 15.0437 17.7035 15.2217C17.93 15.2912 18.1369 15.413 18.3075 15.5772L18.8226 15.0621C18.9135 14.9703 19.0079 14.8815 19.0953 14.7866V14.7866V14.7866C18.8341 14.543 18.5275 14.3531 18.193 14.2278C17.5843 14.0071 16.9183 14.0013 16.3058 14.2113C16.2844 14.2186 16.2632 14.2261 16.2422 14.234C15.5813 14.4825 15.0377 14.9697 14.7186 15.5994C14.606 15.8223 14.5239 16.0594 14.4747 16.3043C14.1829 17.7543 15.0677 19.1815 16.4961 19.5651C16.963 19.6902 17.4594 19.6871 17.93 19.5802C18.3576 19.4837 18.7529 19.2782 19.0776 18.9838C19.4165 18.6721 19.6593 18.2568 19.7865 17.8156C19.8929 17.4418 19.9314 17.052 19.9003 16.6645Z"
        fill="#EEEEEF"
      />
      <defs>
        <linearGradient
          id={id2}
          x1="2.8588"
          y1="20.9897"
          x2="21.5104"
          y2="20.9897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#477CE8" />
          <stop
            offset="1"
            stopColor="#3F7EF1"
          />
        </linearGradient>
        <linearGradient
          id={id3}
          x1="21.9372"
          y1="13.7727"
          x2="21.9372"
          y2="6.04373"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.01" />
          <stop
            offset="1"
            stopOpacity="0.3"
          />
        </linearGradient>
      </defs>
    </>
  );
};
